import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StructureService } from '../../services/structure_service';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

export interface HeizwerteProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
}

export interface HeizwerteState {
    jahr: number;
}

export class Heizwerte extends React.Component<HeizwerteProps, HeizwerteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            jahr: this.props.jahr
        };
    }

    @lazyInject(StructureService) private structureService: StructureService;


    private prefix = 'quelle_';
    private quellen: any = {};
    private suffix = '_orig';

    componentDidMount(): void {
        this.getJahr();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.jahr !== prevProps.jahr) {
            this.getJahr();
        }
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;
        const Section: any = new SectionStyle();
        const width: number = isPdf ? 555 : 655;

        return ({
            main: {
                maxWidth: width,
                minWidth: width,
                display: 'flex',
                flexDirection: 'column'
            },
            ueberschrift: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontSize: '11pt',
                fontWeight: 'bold',
                color: '#555',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            tabelle: {
                fontSize: '9pt',
                marginTop: 15,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                backgroundColor: '#ddd',
                maxWidth: width,
                minWidth: width,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                fontWeight: 'bold',
                color: Section.getPropertyValue('--color-button-text') || '#555',
                backgroundColor: Section.getPropertyValue('--color-section-main') || '#bccae3',
                maxWidth: width,
                minWidth: width
            },
            colgroup: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            colgroup_header: {
            },
            col1: {
                flexBasis: '13%'
            },
            col1_header: {
                flexBasis: '49%'
            },
            col1_2: {
                flexBasis: '49%'
            },
            col2: {
                fontSize: '8pt',
                flexBasis: '36%'
            },
            col2_header: {
                flexBasis: '17%'
            },
            col3: {
                flexBasis: '17%'
            },
            col3_header: {
                flexBasis: '17%'
            },
            col4: {
                flexBasis: '17%'
            },
            col4_header: {
                flexBasis: '17%'
            },
            col5: {
                flexBasis: '17%'
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                boxSizing: 'border-box'
            },
            cell_header: {
            },
            cell1: {
            },
            cell2: {
            },
            cell2_header: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell3: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell3_header: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell4: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell4_header: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell5: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            sub: {
                fontSize: '6pt',
                verticalAlign: 'sub',
                display: 'inline'
            },
            sup: {
                fontSize: '6pt',
                verticalAlign: 'super'
            },
            small: {
                fontSize: '8pt',
                display: 'inline'
            },
            erlaeuterungen: {
                fontSize: '7.5pt',
                color: '#555',
                marginTop: 5,
                borderLeft: '1pt solid white',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            e_row: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row'
            },
            e_col1: {
                flexBasis: isPdf ? '10%' : '11.5%'
            },
            e_col2: {
                flexBasis: isPdf ? '90%' : '88.5%'
            },
            e_cell: {
                textAlign: 'left',
                padding: 0,
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start'
            },
            quellen: {
                fontSize: '7.5pt',
                color: '#555',
                marginTop: 5,
                borderLeft: '1pt solid white',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            q_row: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row'
            },
            q_col1: {
                flexBasis: isPdf ? '10%' : '11.5%'
            },
            q_col2: {
                flexBasis: isPdf ? '90%' : '88.5%'
            },
            q_cell: {
                textAlign: 'left',
                padding: 0,
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start'
            }
        });
    }

    getGruppen(gruppe?: string): any {
        // const kennzahlen_def: Array<any> = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
        const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL_ADMIN, IDs.ENT_PARAMETER_HEIZWERTE);
        // const kennzahlen: Array<string> = Array.from(new Set(kennzahlen_def
        //     .map((kennzahl: any) => (kennzahl.umrechnung || null))))
        //     .filter(element => element !== null);

        return gruppe
            ? (structure.ATTS || [])
                .filter((element: any) =>
                    element.FIELD_GROUP
                    && element.KEY
                    && element.FIELD_GROUP === gruppe
                    && element.KEY.indexOf(this.prefix) !== 0
                    // && kennzahlen.indexOf(element.KEY) !== -1
                )
            : (structure.ATTS || []);
    }

    getJahr(): void {
        const jahrAuswahl: number = this.props.jahr || null;
        let jahrGefunden: number = null;
        this.quellen = {};

        (this.props.data[IDs.ENT_PARAMETER_HEIZWERTE] || []).forEach((data: any) => {
            const jahr: number = data.jahr || null;
            // Wenn wir noch kein Jahr gefunden haben, nehmen wir das
            if (!jahr) {
                jahrGefunden = jahr;
                return;
            }
            // Wir hatten schonmal ein Jahr gefunden
            if (jahrGefunden > jahrAuswahl && jahr <= jahrAuswahl) {
                // Dieses war größer als das Jahr, wir suchen aber eigentlich das Jahr, das gleich oder kleiner ist
                jahrGefunden = jahr;
                return;
            }
            // Wir hatten schonmal ein Jahr, das gleich oder kleiner war
            if (jahrGefunden < jahrAuswahl && jahr <= jahrAuswahl && jahr > jahrGefunden) {
                jahrGefunden = jahr; // Dieses Jahr ist besser
                return;
            }
        });
        this.setState({ jahr: jahrGefunden });
    }

    getParameterQuellen(): Array<any> {
        // const kennzahlen_def: Array<any> = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
        // const kennzahlen: Array<string> = Array.from(new Set(kennzahlen_def
        //     .map((kennzahl: any) => (kennzahl.umrechnung || null))))
        //     .filter(element => element !== null);
        const parameter: any = (this.props.data[IDs.ENT_PARAMETER_HEIZWERTE] || [])
            .find((element: any) => (element.jahr || null) === this.state.jahr);

        return parameter
            ? Object.keys(parameter)
                .map((item: string) => {
                    if (
                        item.indexOf(this.prefix) === 0
                        && item.indexOf(this.suffix) === -1
                        && typeof parameter[item] === 'string'
                        // && kennzahlen.indexOf(item.slice(prefix.length)) !== -1
                    ) {
                        return {
                            parameter: item.slice(this.prefix.length),
                            quelle_tid_orig: parameter[item + this.suffix]
                        };
                    }
                })
                .filter(element => element !== undefined)
                .sort((a: any, b: any) => a.quelle_tid_orig < b.quelle_tid_orig ? -1 : 1)
            : [];
    }

    getQuellen(): any {
        const quellen: any = {};

        (this.props.data[IDs.ENT_QUELLEN] || []).map((item: any) => {
            if (item.tid) {
                quellen[item.tid] = item;
            }
        });

        return quellen;
    }

    getQuellenKuerzel(gruppe: string): Array<string> {
        const energietraeger: Array<any> = this.getGruppen(gruppe) || [];
        const parameter: Array<any> = this.getParameterQuellen() || [];
        const quellen: any = this.getQuellen() || {};

        return Array.from(new Set(energietraeger
            .map((item: any) => {
                return (parameter
                    .find((quelle: any) => {
                        return (quelle.parameter || null) === (item.KEY || null);
                    })
                    || { quelle_tid_orig: null }
                ).quelle_tid_orig;
            })
            .filter(element => element !== null)
            .map((quelle_tid: number) => {
                if (quellen[quelle_tid || null]) {
                    if (!this.quellen[quelle_tid]) {
                        const beschreibung: number = (quellen[quelle_tid] || {}).beschreibung || null;
                        const kuerzel: number = Object.keys(this.quellen).length + 1;
                        this.quellen[quelle_tid] = {
                            beschreibung,
                            kuerzel
                        };
                    }
                    return this.quellen[quelle_tid].kuerzel;
                }
            })
        ));
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return;
        }
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.main} pdf={isPdf}>
                {this.renderUeberschrift()}
                {this.renderTabelle()}
                {this.renderErlaeuterungen()}
                {this.renderQuellen()}
            </WpdfView>
        );
    }

    renderErlaeuterungen(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.erlaeuterungen} pdf={isPdf}>
                <WpdfView style={styles.e_row} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.e_col1 }} pdf={isPdf}>
                        <WpdfView style={styles.e_cell} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Erläuterungen:</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.e_col2 }} pdf={isPdf}>
                        <WpdfView style={styles.e_cell} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>
                                Rm: (Raummeter) übliche Benennung für 1 m³ geschichtetes Holz unter Einschluss der Luftzwischenräume
                            </WpdfText>
                        </WpdfView>
                        <WpdfView style={styles.e_cell} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>
                                Srm: (Schüttraummeter oder -kubikmeter) Raummeter geschütteter Holzteile (z. B. Hackgut, Schüttgut)
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderQuellen(): JSX.Element {
        const colBeschreibung: Array<JSX.Element> = [];
        const isPdf: boolean = this.props.isPdf || false;
        const quellen: Array<any> = Object.values(this.quellen || {})
            .sort((a: any, b: any) => (a.kuerzel || 0) < (b.kuerzel || 0) ? -1 : 1) || [];
        const bezeichnung: string = quellen.length > 1 ? 'Quellen:' : 'Quelle:';
        const styles: any = this.getStyle();

        for (const quelle of quellen) {
            const beschreibung: string = quelle.beschreibung || null;
            const kuerzel: number = quelle.kuerzel || null;
            colBeschreibung.push(
                <WpdfView key={`quelle-${kuerzel}`} style={{ ...styles.q_cell, flexDirection: 'row' }} pdf={isPdf}>
                    {kuerzel &&
                        <WpdfView style={{ ...styles.sup, marginRight: 2 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{kuerzel}</WpdfText>
                        </WpdfView>
                    }
                    <WpdfView pdf={isPdf}><WpdfText pdf={isPdf}>{beschreibung}</WpdfText></WpdfView>
                </WpdfView>
            );
        }

        return colBeschreibung.length
            ?
                <WpdfView style={styles.quellen} pdf={isPdf}>
                    <WpdfView style={styles.q_row} pdf={isPdf}>
                        <WpdfView style={{ ...styles.colgroup, ...styles.q_col1 }} pdf={isPdf}>
                            <WpdfView style={styles.q_cell} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>=&gt; {bezeichnung}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                        <WpdfView style={{ ...styles.colgroup, ...styles.q_col2 }} pdf={isPdf}>
                            {colBeschreibung}
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            : null;
    }

    renderTabelle(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const jahr: number = this.props.jahr || null;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col1_header }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header, borderTop: 0, borderLeft: 0 }}
                            pdf={isPdf}
                        >
                            <WpdfText pdf={isPdf}>Energieträger {jahr}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2_header, borderTop: 0 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Mengeneinheit</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col3_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell3_header, borderTop: 0 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Heizwert (kJoule)</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.colgroup, ...styles.colgroup_header, ...styles.col4_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell4_header, borderTop: 0 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Heizwert (kWh)</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {this.renderTabelleGruppen()}
            </WpdfView>
        );
    }

    renderTabelleEnergietraeger(gruppe: string): Array<JSX.Element> {
        const colEnergietraeger: Array<JSX.Element> = [];
        const colHeizwertKj: Array<JSX.Element> = [];
        const colHeizwertKwh: Array<JSX.Element> = [];
        const colMengeneinheit: Array<JSX.Element> = [];
        const energietraeger: Array<any> = this.getGruppen(gruppe) || [];
        const isPdf: boolean = this.props.isPdf || false;
        const options: any = { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true };
        const quellenKuerzel: Array<string> = this.getQuellenKuerzel(gruppe) || [];
        const styles: any = this.getStyle();
        const data: Array<any> = (this.props.data[IDs.ENT_PARAMETER_HEIZWERTE] || [])
            .filter((element: any) => (element.jahr || null) === this.state.jahr);

        for (const item of energietraeger) {
            const info: string = item.INFO || null;
            const key: string = item.KEY || null;
            const name: string = item.NAME || '';
            const isColgroupPrev: boolean = (energietraeger.length === 1 || !(name.indexOf('(') > -1 && name.indexOf('(') > -1));
            const kuerzel: string = quellenKuerzel.length ? quellenKuerzel.join(',') : null;
            const nameMod: string = name.replace(/.*\(|\).*/g, '');
            let unit: string = (item.FIELD_UNIT || null);

            switch (name) {
                case 'Biogas [kg]': unit += ' (Biogas)'; break;
                case 'Biogas [m³]': unit += ' (Biogas)'; break;
                case 'Biodiesel': // no break
                case 'Bioethanol': // no break
                case 'Braunkohle': // no break
                case 'Steinkohle': unit += ` (${name})`; break;
                case 'Erdgas CNG [kg]': unit += ' (CNG)'; break;
                case 'Erdgas LNG [kg]' : unit += ' (LNG)'; break;
            }
            const value: number = data[0] ? (data[0][key] || null) : null;
            const valueKj: string = value !== null ? (value * 3600).toLocaleString('de-DE', options) : null;
            const valuekwh: string = value !== null ? value.toLocaleString('de-DE', options) : null;

            if (!isColgroupPrev) {
                colEnergietraeger.push(
                    <WpdfView key={`energietraeger-${key}`} style={{ ...styles.cell, ...styles.cell2, flexDirection: 'row' }} pdf={isPdf}>
                        <WpdfView pdf={isPdf}><WpdfText pdf={isPdf}>{nameMod}</WpdfText></WpdfView>
                        {info && <WpdfView pdf={isPdf}><WpdfText pdf={isPdf}>&nbsp;{info}</WpdfText></WpdfView>}
                        {kuerzel &&
                            <WpdfView style={{ ...styles.sup, marginLeft: 2 }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{kuerzel}</WpdfText>
                            </WpdfView>
                        }
                    </WpdfView>
                );
            }
            colMengeneinheit.push(
                <WpdfView key={`mengeneinheit-${key}`} style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>{unit}</WpdfText>
                </WpdfView>
            );
            colHeizwertKj.push(
                <WpdfView key={`heizwert_kj-${key}`} style={{ ...styles.cell, ...styles.cell4 }} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>{valueKj}</WpdfText>
                </WpdfView>
            );
            colHeizwertKwh.push(
                <WpdfView key={`heizwert_kwh-${key}`} style={{ ...styles.cell, ...styles.cell5 }} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>{valuekwh}</WpdfText>
                </WpdfView>
            );
        }

        return [
            (colEnergietraeger.length
                ?
                    <WpdfView key='energietraeger' style={{ ...styles.colgroup, ...styles.col2 }} pdf={isPdf}>
                        {colEnergietraeger}
                    </WpdfView>
                : null
            ),
            <WpdfView key='mengeneinheit' style={{ ...styles.colgroup, ...styles.col3 }} pdf={isPdf}>
                {colMengeneinheit}
            </WpdfView>,
            <WpdfView key='heizwert_kj' style={{ ...styles.colgroup, ...styles.col4 }} pdf={isPdf}>
                {colHeizwertKj}
            </WpdfView>,
            <WpdfView key='heizwert_kwh' style={{ ...styles.colgroup, ...styles.col5 }} pdf={isPdf}>
                {colHeizwertKwh}
            </WpdfView>
        ];
    }

    renderTabelleGruppen(): Array<JSX.Element> {
        const isPdf: boolean = this.props.isPdf || false;
        const rows: Array<JSX.Element> = [];
        const styles: any = this.getStyle();
        const gruppen: Array<string> = (this.getGruppen() || [])
            .filter((element: any, index: any, array: any) => (
                element.FIELD_GROUP
                && array.map((item: any) => item.FIELD_GROUP).indexOf(element.FIELD_GROUP) === index
            ))
            .map((item: any) => item.FIELD_GROUP);

        gruppen.forEach((gruppe: any, key: number) => {
            const energietraeger: Array<any> = this.getGruppen(gruppe) || [];

            if (!energietraeger.length) {
                return;
            }
            const info: string = energietraeger[0].INFO || null;
            const name: string = energietraeger[0].NAME || '';
            const isColgroup: boolean = (energietraeger.length === 1 || !(name.indexOf('(') > -1 && name.indexOf('(') > -1));
            const quellenKuerzel: Array<string> = this.getQuellenKuerzel(gruppe) || [];
            const kuerzel: string = quellenKuerzel.length ? quellenKuerzel.join(',') : null;
            const stylesCols: any = isColgroup ? styles.col1_2 : styles.col1;
            rows.push(
                <WpdfView key={`gruppe-${key}`} style={styles.row} pdf={isPdf}>
                    <WpdfView style={{ ...styles.colgroup, ...stylesCols }} pdf={isPdf}>
                        <WpdfView
                            style={{ ...styles.cell, ...styles.cell1, flexDirection: 'row', borderLeft: 0 }}
                            pdf={isPdf}
                        >
                            <WpdfView style={{ margin: 'auto', marginLeft: 0, marginRight: 0 }} pdf={isPdf}>
                                <WpdfText style={{ margin: 'auto', marginLeft: 0, marginRight: 0 }} pdf={isPdf}>{gruppe}</WpdfText>
                            </WpdfView>
                            {isColgroup && info &&
                                <WpdfView style={{ margin: 'auto', marginLeft: 0, marginRight: 0 }} pdf={isPdf}>
                                    <WpdfText style={{ margin: 'auto', marginLeft: 0, marginRight: 0 }} pdf={isPdf}>&nbsp;{info}</WpdfText>
                                </WpdfView>
                            }
                            {isColgroup && kuerzel &&
                                <WpdfView style={{ ...styles.sup, margin: 'auto', paddingBottom: 4, marginLeft: 2 }} pdf={isPdf}>
                                    <WpdfText style={{ margin: 'auto', marginLeft: 0 }} pdf={isPdf}>{kuerzel}</WpdfText>
                                </WpdfView>
                            }
                        </WpdfView>
                    </WpdfView>
                    {this.renderTabelleEnergietraeger(gruppe)}
                </WpdfView>
            );
        });

        return rows;
    }

    renderUeberschrift(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    II) Heizwerte der Energieträger und Faktoren für die Umrechnung von spezifischen{!isPdf && <br />}{'\n'}
                    &nbsp;&nbsp;&nbsp; Mengeneinheiten in Wärmeeinheiten
                </WpdfText>
            </WpdfView>
        );
    }
}
